import NudosGenericModal from 'components/NudosComponents/NudosGenericModal/NudosGenericModal';
import BillingDetailModalContent from './BillingDetailModalContent/BillingDetailModalContent';
import { ICountryDetail } from 'types/bussines';

interface IBillingDetailModalProps {
  billingInvoiceId: number;
  countryList: ICountryDetail[];
  isOpen: boolean;
  onClose: () => void;
}

const BillingDetailModal = ({ billingInvoiceId, countryList, isOpen, onClose }: IBillingDetailModalProps) => {
  if (!isOpen) return null;
  return (
    <NudosGenericModal
      modalContent={
        <BillingDetailModalContent billingInvoiceId={billingInvoiceId} countryList={countryList} onClose={onClose} />
      }
      closesOnClickOutside
      closeModalCallback={onClose}
    />
  );
};

export default BillingDetailModal;
